/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const ratingCategoryDtoSchema = z.object({
  categoryKey: z.optional(z.string()),
  generalScore: z.int().nullish(),
  criterion1Score: z.int().nullish(),
  criterion2Score: z.int().nullish(),
  criterion3Score: z.int().nullish(),
  comment: z.string().nullish(),
  computedScore: z.number().nullish(),
});
